<!-- @format -->

@if (description) {
  <p>
    <transloco [content]="description | translate: { count: items.length }" />
  </p>
}
@if (listShowState !== ListShowState.ALWAYS_SHOWING_ALL) {
  <p class="guidance truncated-results">
    @if (listShowState === ListShowState.SHOWING_LESS) {
      {{ "SHOW_MORE_LIST.SHOWING_LESS_ITEMS" | translate: { count: INITIALLY_SHOWN_LIST_ITEMS_MAX_COUNT } }}
    }
    @if (listShowState === ListShowState.SHOWING_MORE) {
      {{ showingAllItemsText || "SHOW_MORE_LIST.SHOWING_ALL_ITEMS" | translate: { count: items.length } }}
    }
    <button (click)="toggleListShowState()" class="link-button">{{
      (listShowState === ListShowState.SHOWING_LESS ? "SHOW_MORE_LIST.SHOW_MORE" : "SHOW_MORE_LIST.SHOW_LESS") | translate
    }}</button>
  </p>
}
<ul>
  @for (
    listItem of items.slice(0, listShowState === ListShowState.SHOWING_LESS ? INITIALLY_SHOWN_LIST_ITEMS_MAX_COUNT : undefined);
    track listItem
  ) {
    <li>
      {{ listItem }}
    </li>
  }
</ul>
